import React from "react";

export type NacIconProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 34,
    height: 34,
  },
  medium: {
    width: 34,
    height: 34,
  },
  large: {
    width: 34,
    height: 34,
  },
};

export const NacIcon: JSX.Element & any = React.forwardRef<
  SVGSVGElement,
  NacIconProps
>((props, ref) => {
  const { size = "medium", width, height, color = "#1D1929" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];
  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.608 7.94948C15.4053 7.94948 15.0918 7.87956 14.7295 7.77142C14.945 7.52959 15.0785 7.21327 15.0785 6.86454C15.0785 6.61039 15.0088 6.37227 14.8876 6.16796C15.3179 5.93741 15.6113 5.48318 15.6113 4.96184C15.6113 4.20784 14.9979 3.59439 14.2439 3.59439H10.4959C10.0628 3.59439 9.64979 3.68087 9.27112 3.83463C9.21211 3.68827 9.16121 3.53962 9.11542 3.38956C8.93718 2.80535 8.82287 2.20511 8.48506 1.67338C7.84519 0.666111 6.72309 0 5.44335 0C5.0594 0 4.68865 0.0590024 4.34415 0.170667C3.75395 0.361764 3.23384 0.721767 2.78542 1.18921L0.789204 1.46397C0.505816 1.50307 0.262057 1.66792 0.120451 1.91661C-0.021155 2.1653 -0.0387677 2.45891 0.0721921 2.72274L0.963393 4.84049C0.818617 5.47279 0.744644 6.08958 0.744644 6.63469C0.744644 10.8314 4.14724 14.2372 8.34733 14.2372C12.1372 14.2372 15.2772 11.4613 15.8516 7.83553C15.8389 7.91514 15.7505 7.94948 15.608 7.94948ZM10.4957 4.42677H14.2437C14.5387 4.42677 14.779 4.66683 14.779 4.96202C14.779 5.25703 14.5389 5.49727 14.2437 5.49727H13.7109V6.32947C14.0061 6.32947 14.2462 6.56953 14.2462 6.86472C14.2462 7.15973 14.0061 7.39996 13.7109 7.39996H12.9499V8.23216C13.2451 8.23216 13.4851 8.47222 13.4851 8.76741C13.4851 9.0626 13.2451 9.30266 12.9499 9.30266H10.4957C9.15153 9.30266 8.05778 8.20909 8.05778 6.86472C8.05778 5.52034 9.15153 4.42677 10.4957 4.42677ZM12.7618 11.7658C11.5358 12.8229 9.96805 13.405 8.34733 13.405C4.61415 13.405 1.57702 10.3679 1.57702 6.63469C1.57702 4.71667 2.65386 1.59307 4.60076 0.962357C4.86742 0.876054 5.15098 0.832199 5.44353 0.832199C6.3962 0.832199 7.27067 1.31355 7.78267 2.11969C7.98011 2.43055 8.08825 2.81732 8.20255 3.22664C8.24042 3.36208 8.27829 3.4977 8.3195 3.63244C8.37287 3.80751 8.44508 4.0215 8.54283 4.248C7.74533 4.84489 7.22593 5.79404 7.22593 6.86454C7.22593 8.66772 8.69289 10.1347 10.4961 10.1347H12.9502C13.7042 10.1347 14.3177 9.52124 14.3177 8.76724C14.3177 8.67759 14.3069 8.59076 14.2904 8.50586C14.4697 8.56223 14.6435 8.61242 14.8075 8.65399C14.4329 9.85253 13.7262 10.9343 12.7618 11.7658Z"
        fill={color}
      />
      <path
        d="M5.24956 4.25229C5.72447 4.25229 6.10946 3.86729 6.10946 3.39238C6.10946 2.91746 5.72447 2.53247 5.24956 2.53247C4.77464 2.53247 4.38965 2.91746 4.38965 3.39238C4.38965 3.86729 4.77464 4.25229 5.24956 4.25229Z"
        fill={color}
      />
    </svg>
  );
});

NacIcon.displayName = "NacIcon";
